import React from 'react';

interface Account {
  account_name: string;
  account_id: string;
  source?: string;
  account_type: string;
  market_value?: number;
}

interface AccountsTableProps {
  accounts: Account[];
  formatCurrency: (amount: number) => string;
}

export const AccountsTable: React.FC<AccountsTableProps> = ({
  accounts,
  formatCurrency
}) => {
  if (!accounts || accounts.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No accounts available
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground w-[30%]">
              Account Name
            </th>
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">
              Account ID
            </th>
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">
              Source
            </th>
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">
              Account Type
            </th>
            <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground">
              Market Value
            </th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((account, index) => (
            <tr
              key={`${account.account_id}-${index}`}
              className="border-b border-gray-100 hover:bg-gray-50"
            >
              <td className="py-3 px-4 text-sm">{account.account_name}</td>
              <td className="py-3 px-4 text-sm font-mono text-muted-foreground">
                {account.account_id}
              </td>
              <td className="py-3 px-4">
                {account.source && (
                  <span>{account.source}</span>
                )}
              </td>
              <td className="py-3 px-4 text-sm">{account.account_type}</td>
              <td className="py-3 px-4 text-sm text-right font-medium">
                {account.market_value !== undefined
                  ? formatCurrency(account.market_value)
                  : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
